import confetti from 'canvas-confetti';
import { useReducedMotion } from 'framer-motion';
import { useEffect, useRef } from 'react';

const CONFETTI_PARTICLE_COUNT = 100;
const CONFETTI_SPREAD_DEGREES = 70;
const CONFETTI_ORIGIN_Y = 0.6;

export function useConfettiEffect(): void {
  const hasFiredRef = useRef(false);
  const reduceMotion = useReducedMotion() ?? false;

  useEffect(() => {
    if (hasFiredRef.current || reduceMotion) {
      return;
    }

    hasFiredRef.current = true;

    void confetti({
      particleCount: CONFETTI_PARTICLE_COUNT,
      spread: CONFETTI_SPREAD_DEGREES,
      origin: { y: CONFETTI_ORIGIN_Y },
      disableForReducedMotion: true,
    });
  }, [reduceMotion]);
}
